<template>
  <div v-if="status || message">
    <!-- STATUS_NO_RESUME -->
    <template v-if="status === STATUS_NO_RESUME">
      <h3 class="popup-full__title">{{ $tVacancy('You have no resume') }}?</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('You should create resume for responding to the vacancy') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="createResume"
                class="popup-full__btn  base-btn base-btn--green">
          <BaseSvg name="ico-plus" width="1rem" height="1rem"/>
          <span class="base-btn__text">
            {{ $tVacancy('Create') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END NO RESUME -->

    <!-- NO PASSPORT -->
    <template v-else-if="status === STATUS_NO_PASSPORTS_SELECTED">
      <h3 class="popup-full__title">{{ $tVacancy('You must have passport') }}</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('You must have passport description') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="goToResume(1, 'documents')"
                class="popup-full__btn  base-btn base-btn--green">
          <span class="base-btn__text">
            {{ $tVacancy('Go to resume') }}
          </span>
        </button>
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END NO PASSPORT -->


    <!-- END STATUS_NO_PASSPORTS -->
    <template v-else-if="status === STATUS_NO_PASSPORTS">
      <h3 class="popup-full__title">{{ $tVacancy('Resume sent no passport') }}</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('Resume sent no passport description') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="goToResumePassport"
                class="popup-full__btn  base-btn base-btn--green">
          <span class="base-btn__text">
            {{ $tVacancy('Go to resume') }}
          </span>
        </button>
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END STATUS_NO_PASSPORTS -->


    <!-- END STATUS_SUCCESS -->
    <template v-else-if="status === STATUS_SUCCESS">
      <h3 class="popup-full__title">{{ $tVacancy('Resume sent') }}</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('Resume sent description') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="goToMyVacancies"
                class="popup-full__btn  base-btn base-btn--green">
          <span class="base-btn__text">
            {{ $tVacancy('Go to my vacancies') }}
          </span>
        </button>
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END STATUS_SUCCESS -->


    <!-- END STATUS_PASSPORTS_NO_MODERATE -->
    <template v-else-if="status === STATUS_PASSPORTS_NO_MODERATE">
      <h3 class="popup-full__title">{{ $tVacancy('Resume sent passport no moderate') }}</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('Resume sent passport no moderate description') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="goToResumePassport"
                class="popup-full__btn  base-btn base-btn--green">
          <span class="base-btn__text">
            {{ $tVacancy('Go to resume') }}
          </span>
        </button>
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END STATUS_PASSPORTS_NO_MODERATE -->


    <!-- STATUS_RESUME_FOUNT_ON_THIS_VACANCY -->
    <template v-else-if="status === STATUS_RESUME_FOUNT_ON_THIS_VACANCY">
      <h3 class="popup-full__title">{{ $tVacancy('This resume found on this vacancy') }}</h3>
      <div class="popup-full__text text">
        <p>{{ $tVacancy('This resume found on this vacancy description') }}</p>
      </div>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END STATUS_RESUME_FOUNT_ON_THIS_VACANCY -->


    <!-- OTHER -->
    <template v-else-if="message">
      <h3 class="popup-full__title">{{ message }}</h3>
      <div class="popup-full__buttons">
        <button type="button"
                @click.prevent="close"
                class="popup-full__btn  base-btn base-btn--outline-grey">
          <span class="base-btn__text">
            {{ $tVacancy('Close') }}
          </span>
        </button>
      </div>
    </template>
    <!-- END OTHER -->
  </div>
</template>

<script>
  const STATUS_SUCCESS = 'STATUS_SUCCESS'
  const STATUS_NO_PASSPORTS_SELECTED = 'STATUS_NO_PASSPORTS_SELECTED'
  const STATUS_NO_PASSPORTS = 'STATUS_NO_PASSPORTS'
  const STATUS_NO_RESUME = 'RESUME_NOT_FOUND'
  const STATUS_PASSPORTS_NO_MODERATE = 'STATUS_PASSPORTS_NO_MODERATE'
  const STATUS_RESUME_FOUNT_ON_THIS_VACANCY = 'STATUS_RESUME_FOUNT_ON_THIS_VACANCY'

  export default {
    name: 'RespondOnVacancyStatuses',
    props: {
      status: String,
      message: String
    },
    data() {
      return {
        STATUS_SUCCESS,
        STATUS_NO_RESUME,
        STATUS_NO_PASSPORTS_SELECTED,
        STATUS_NO_PASSPORTS,
        STATUS_PASSPORTS_NO_MODERATE,
        STATUS_RESUME_FOUNT_ON_THIS_VACANCY,
      }
    },
    computed: {

    },
    methods: {
      close() {
        this.$emit('close')
      },

      createResume() {
        this.close()
        this.$vModal.open('after-respond-without-resume')
      },
      goToMyVacancies() {
        // const isShownModalInfoResult = isShownModalInfo()
        // setShownModalInfo()

        this.$router.push({
          name: 'account-my-vacancies',
          query: {
            showModalInfo: false // !isShownModalInfoResult ? 'true' : null
          }
        })

        this.close()
      },
      goToResumePassport() {
        this.close()
        this.$vModal.open('after-respond-without-resume')
      },
      goToResume() {
        this.close()
        this.$vModal.open('after-respond-without-resume')
      }
    }
  }
</script>

<style lang="less">

</style>
